// removed by extract-text-webpack-plugin
module.exports = {"table_ui":"_2Bs0C","table_add":"-SKUR","table_delete":"MRXdv","root":"_3DNht","headline":"_3JJVo","headline_cont":"_3yVDi","headline_icon":"_24Ylr","table":"_1Zb1Y _2Bs0C","green":"_1yLGu","orange":"_1opyh","blue":"_2ng5R","batchRow":"_3DmWt","search":"_2qFKJ","search_row":"_39V8n","search_clear":"_2wyzV","tableMoreInfo":"r8kFx"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/sent/Sent.css
// module id = 391
// module chunks = 0